module.exports = __webpack_public_path__ + "img/美妆日化行业数字化转型场景图谱.ffe827b0.jpg";